import { Heading,Box, Link, Text, Grid, Center, List, ListItem, ListIcon, OrderedList, UnorderedList } from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import React from "react";

const ExperienceAndperspective = ({title, link}) => {
  return (
    <Card>
      <CardHeader>
        <Link href={link}>
          <Heading as='h3' size='lg'>{title}</Heading>
        </Link>
      </CardHeader>
      <CardBody mt="30px">
        <Grid
            templateColumns={{ sm: "1fr", lg: "1.2fr 1.8fr" }}
            templateRows={{ sm: "1fr", lg: "1fr" }}
            gap='24px'
            mb={{ lg: "26px" }}>
            <Grid
                gap='24px'
                mb={{ lg: "26px" }}>
                <Grid>
                  <Link color='#BE830E' target="_blank" href='https://forms.office.com/Pages/ResponsePage.aspx?id=32quJr5hP0SNxGUxthqaOKNuX5OvLmZOssjGlr4FJL1URFFBQlhWOE0zMjBJOTk0MFU2UTFSR0g3Mi4u'>Give your feedback</Link>
                  <Link color='#BE830E' target="_blank" href="https://forms.office.com/Pages/AnalysisPage.aspx?AnalyzerToken=4FVJcKKaXYgkKuiXNN4wef12iEza0ILV&id=32quJr5hP0SNxGUxthqaOKNuX5OvLmZOssjGlr4FJL1URFFBQlhWOE0zMjBJOTk0MFU2UTFSR0g3Mi4u">Feedback from other users</Link>
                  <Link color='#BE830E' target="_blank" href='https://www.aliveandthrive.org/en/contact-us'>Contact us</Link>
                </Grid>
                {/* <UnorderedList>
                    <ListItem>link info 1</ListItem>
                    <ListItem>link info 2</ListItem>
                    <ListItem>link info 3</ListItem>
                    <ListItem>link info 4</ListItem>
                </UnorderedList> */}
            </Grid>
            {/* <Center>
                <Box
                    as='video'
                    controls
                    src='https://archive.org/download/BigBuckBunny_124/Content/big_buck_bunny_720p_surround.mp4'
                    alt='Big Buck Bunny'
                    objectFit='contain'
                    sx={{
                    aspectRatio: '16/9'
                    }}
                />
            </Center> */}
        </Grid>
      </CardBody>
    </Card>
    
  );
};

export default ExperienceAndperspective;
